export default __webpack_public_path__ + "static/media/style.9ab307be.less";